import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchMembershipCards = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.MEMBERSHIP_CARD.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
      // total_count:totalItems
    },
  });
};

export const fetchMembershipOrders = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.MEMBERSHIP_CARD.ORDERS_LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
      // total_count:totalItems
    },
  });
};

export const fetchMembershipDropdown = () => {
  return axiosInstance.get(
    `${EndPoints.MEMBERSHIP_CARD.LIST_DD}?is_active=true&zone_id=${zone_id}`
  );
};

export const createMembership = (payload) => {
  return axiosInstance.post(EndPoints.MEMBERSHIP_CARD.CREATE, payload);
};

export const updateMembership = (payload) => {
  return axiosInstance.put(EndPoints.MEMBERSHIP_CARD.UPDATE, payload);
};

export const deleteMembership = (payload) => {
  const url = EndPoints.MEMBERSHIP_CARD.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.MEMBERSHIP_CARD.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
